<template>
    <section>
        <b-overlay :show="loadingTriggerList" no-wrap opacity="1">
        </b-overlay>
        <PageTitle :main="$t('rtaTriggerList')" sub="" imagem="pop2.png" />
        <section>
            <section>
                <Filters ref="filtersComponent" @filter-changed="loadOpenTriggers" @filter-reset="resetFilters"
                    @gerar-rta-clicked="handleGenerateRtaClick"
                    @vincular-rta-clicked="handleLinkRtaClick"
                    @justificar-clicked="handleJustifyClick"
                    :headerToExport="tableColumns"
                    :dataToExport="tableData" fileName="Lista de Gatilhos RTAs" :showExport="true" :showStatusSwitches="true" :showActionButtons="true" :loadingLinkRta="loadingLinkRta" />
            </section>
            <section>
                <Table ref="tableRta" :tableColumns="tableColumns" :tableData="tableData" :priorize-func="askOpenRta"
                    :justify-func="justifyRta" :record-func="showTriggerInfo" :db-click-func="openRtaFromRecord" :hideColsArr="[]" @column-filters-changed="saveColumnFilters"/>
            </section>
            <Overview :filters="overviewFilters"/>

        </section>
        <b-modal id="justifyTriggerModal" title="Justificar RTA" hide-footer>
            <textarea :disabled="!canJustify" class="justifyClass" v-model="justifyTxt"
                @input="e => justifyTxt = e.target.value" placeholder="Digite sua Justificativa"></textarea>
            <RtaModalButtons v-if="canJustify" :ok-func="handleJustify"
                :cancel-func="() => this.$bvModal.hide('justifyTriggerModal')" />
        </b-modal>

        <b-modal id="openRtaModal" title="Abrir RTA" hide-footer>
            <p>Tem certeza que deseja abrir uma RTA para este disparo gatilho?</p>
            <RtaModalButtons :ok-func="openRtaFromTrigger" :cancel-func="() => this.$bvModal.hide('openRtaModal')" />
        </b-modal>

        <GerarRtaModal
            :selectedTriggers="selectedTriggers"
            @confirmar="confirmGenerateRta"
            @cancelar="cancelGenerateRta" />

        <JustificarMassaModal
            :selectedTriggersCount="selectedTriggersForJustify.length"
            @confirmar="confirmBulkJustify"
            @cancelar="cancelBulkJustify" />

        <VincularRtaModal
            :selectedTriggersCount="selectedTriggersForLink.length"
            :availableRtas="availableRtas"
            :processOptions="processOptions"
            @confirmar="confirmLinkRta"
            @cancelar="cancelLinkRta" />

        <TriggerInfoModal
            :triggerData="selectedTriggerInfo" />
    </section>
</template>

<script>
import PageTitle from "../template/PageTitle.vue";
import Filters from "./commons/Filters.vue";
import Table from "./commons/Table.vue";
import Overview from "./commons/Overview.vue";
import axios from 'axios';
import { defaultSuccess, showError, urlMainAPI } from '../../global';
import RtaModalButtons from "./commons/RtaModalButtons.vue";
import GerarRtaModal from "./modals/GenerateRtaModal.vue";
import JustificarMassaModal from "./modals/JustifyRtaModal.vue";
import VincularRtaModal from "./modals/LinkRtaModal.vue";
import TriggerInfoModal from "./modals/TriggerInfoModal.vue";
import * as moment from 'moment'
export default {
    name: "TriggerRTA",
    components: {
        PageTitle,
        Filters,
        Table,
        RtaModalButtons,
        Overview,
        GerarRtaModal,
        JustificarMassaModal,
        VincularRtaModal,
        TriggerInfoModal
    },
    data() {
        return {
            loadingTriggerList: false,
            loadingLinkRta: false,
            rtaDefaultDeadlineDays: 7,
            justifyTxt: "",
            justifyId: null,
            canJustify: false,
            keepFilters: null,
            openRtaObj: null,
            selectedTriggers: [],
            selectedTriggersForJustify: [],
            selectedTriggersForLink: [],
            selectedTriggerInfo: null,
            availableRtas: [],
            processOptions: [],
            allTriggersData: [],
            columnFiltersStorageKey: 'rta-triggers-column-filters',
            defaultFilters: {
                processId: null,
                workshiftId: null,
                startDate: "",
                endDate: "",
                statusPendente: false,
                statusRtaGerada: false,
                statusJustificada: false,
            },
            tableColumns: [
                { field: "checkbox", key: 'checkbox', title: '', align: "center", sortBy: "", width: 60, ellipsis: { lineClamp: 1 } },
                { field: "id", key: 'id', title: 'Código de Desvio', align: "center", sortBy: "", width: 130, ellipsis: { lineClamp: 1 } },
                { field: "creationDate", key: 'creationDate', title: 'Data do Disparo', align: "center", sortBy: "", width: 140, ellipsis: { lineClamp: 1 } },
                { field: "indicator", key: 'indicator', title: 'Indicador', align: "center", sortBy: "", width: 140, ellipsis: { lineClamp: 1 } },
                { field: "process", key: 'process', title: 'Processo', align: "center", sortBy: "", width: 130, ellipsis: { lineClamp: 1 } },
                { field: "workshift", key: 'workshift', title: 'Turno', align: "center", sortBy: "", width: 90, ellipsis: { lineClamp: 1 } },
                { field: "trigger", key: 'trigger', title: 'Gatilho', align: "center", sortBy: "", width: 100, ellipsis: { lineClamp: 1 } },
                { field: "responsible", key: 'responsible', title: 'Responsável', align: "center", sortBy: "", width: 140, ellipsis: { lineClamp: 1 } },
                { field: "lowerLimitValue", key: 'lowerLimitValue', title: 'Limite Inferior', align: "center", sortBy: "", width: 120, ellipsis: { lineClamp: 1 } },
                { field: "upperLimitValue", key: 'upperLimitValue', title: 'Limite Superior', align: "center", sortBy: "", width: 120, ellipsis: { lineClamp: 1 } },
                { field: "prevValue", key: 'prevValue', title: 'Valor Previsto', align: "center", sortBy: "", width: 120, ellipsis: { lineClamp: 1 } },
                { field: "realValue", key: 'realValue', title: 'Valor Real', align: "center", sortBy: "", width: 110, ellipsis: { lineClamp: 1 } },
                { field: "record", key: 'record', title: 'Registro', align: "center", sortBy: "", width: 130, ellipsis: { lineClamp: 1 } },
            ],
            tableData: [],
            overviewFilters:null,
        }
    },
    methods: {
        filterByRecordStatus(data, filters) {
            if (!filters.statusPendente && !filters.statusRtaGerada && !filters.statusJustificada) {
                return data;
            }

            return data.filter(trigger => {
                const record = trigger.record || 'Pendente';

                if (filters.statusPendente && record === 'Pendente') return true;
                if (filters.statusJustificada && record === 'Justificada') return true;
                if (filters.statusRtaGerada && record !== 'Pendente' && record !== 'Justificada') return true;

                return false;
            });
        },

        onlyStatusFiltersChanged(oldFilters, newFilters) {
            if (!oldFilters) return false;

            const apiFiltersChanged =
                oldFilters.processId !== newFilters.processId ||
                oldFilters.workshiftId !== newFilters.workshiftId ||
                oldFilters.startDate !== newFilters.startDate ||
                oldFilters.endDate !== newFilters.endDate;

            const statusFiltersChanged =
                oldFilters.statusPendente !== newFilters.statusPendente ||
                oldFilters.statusRtaGerada !== newFilters.statusRtaGerada ||
                oldFilters.statusJustificada !== newFilters.statusJustificada;

            return !apiFiltersChanged && statusFiltersChanged;
        },

        applyLocalStatusFilter(filters) {
            this.keepFilters = { ...filters };
            const filteredData = this.filterByRecordStatus(this.allTriggersData, filters);
            this.tableData = filteredData.sort((a, b) => a.id - b.id);
        },

        isTriggerPendent(trigger) {
            return trigger.record === 'Pendente';
        },

        getInvalidTriggers(triggers) {
            return triggers.filter(t => !this.isTriggerPendent(t));
        },

        validateTriggersForAction(triggers, action){
            const invalidTriggers = this.getInvalidTriggers(triggers);

            if (invalidTriggers.length > 0) {
                const triggerList = invalidTriggers
                    .map(t => `#${t.id}`)
                    .join(", ");

                showError(`Apenas gatilhos pendentes podem ${action}.`);
                showError(`Gatilhos inválidos: ${triggerList}`)
            }

            return invalidTriggers.length === 0;
        },

        async resetFilters() {
            if (this.$refs.tableRta) {
                this.$refs.tableRta.resetAllColumnFilters();
            }
            this.clearColumnFilters();
            this.defaultFilters = {
                processId: null,
                workshiftId: null,
                startDate: "",
                endDate: "",
                statusPendente: false,
                statusRtaGerada: false,
                statusJustificada: false,
            };

            this.allTriggersData = [];
            await this.loadOpenTriggers(this.defaultFilters);
        },

        saveColumnFilters(columnFilters) {
            try {
                localStorage.setItem(this.columnFiltersStorageKey, JSON.stringify(columnFilters));
            } catch (error) {
                console.error('Erro ao salvar filtros de coluna no localStorage:', error);
            }
        },

        loadColumnFilters() {
            try {
                const savedFilters = localStorage.getItem(this.columnFiltersStorageKey);
                if (savedFilters) {
                    const filters = JSON.parse(savedFilters);
                    this.$nextTick(() => {
                        if (this.$refs.tableRta) {
                            this.$refs.tableRta.loadColumnFilters(filters);
                        }
                    });
                    return true;
                }
            } catch (error) {
                console.error('Erro ao carregar filtros de coluna do localStorage:', error);
            }
            return false;
        },

        clearColumnFilters() {
            try {
                localStorage.removeItem(this.columnFiltersStorageKey);
            } catch (error) {
                console.error('Erro ao limpar filtros de coluna do localStorage:', error);
            }
        },

        askOpenRta(obj) {
            this.openRtaObj = obj;

            this.$bvModal.show('openRtaModal');
        },

        async openRtaFromTrigger() {
            this.$bvModal.hide('openRtaModal');
            if (this.openRtaObj == null) return;

            this.loadingTriggerList = true;

            let date = new Date();

            let rtaToSave = [
                {
                    id: -9999,
                    rtaCode: "",
                    indicatorId: this.openRtaObj.indicatorId,
                    processId: this.openRtaObj.processId,
                    workshiftId: this.openRtaObj.workshiftId,
                    productId: this.openRtaObj.productId,
                    equipmentId: this.openRtaObj.equipmentId,
                    triggerId: this.openRtaObj.id,
                    lowerLimit: this.openRtaObj.lowerLimit,
                    upperLimit: this.openRtaObj.upperLimit,
                    target: this.openRtaObj.target,
                    value: this.openRtaObj.value,
                    creationDate: moment(Date.now()).format("YYYY-MM-DDTHH:mm:ss"),
                    deadline: moment(date.setDate(date.getDate() + this.rtaDefaultDeadlineDays)).format("YYYY-MM-DDTHH:mm:ss"),
                    actionPlanResponsibleId: null,
                    accuracyResponsibleid: null,
                    generalResponsibles: "",
                    relatedRtaId: null,
                    efficiencyRTAId: null,
                    status: 0,
                    lastUpdate: moment(Date.now()).format("YYYY-MM-DDTHH:mm:ss"),
                }
            ];

            let rtaDetails = {}

            await axios.post(`${urlMainAPI}/saverta/${true}`, rtaToSave)
                .then((res) => {
                    rtaDetails = { ...res.data[0] }
                    rtaDetails.code = res.data[0].rtaCode;
                    rtaDetails.auxResponsibles = res.data[0].generalResponsibles;
                    rtaDetails.mainRespId = res.data[0].actionPlanResponsibleId;
                    rtaDetails.efficiencyRespId = res.data[0].accuracyResponsibleid;
                    rtaDetails.trigger = this.openRtaObj.trigger;
                    rtaDetails.description = "";

                    rtaDetails.formattedCreationDate = moment(res.data[0].creationDate).format("YYYY-MM-DD");
                    rtaDetails.formattedDeadline = moment(res.data[0].deadline).format("YYYY-MM-DD");

                    defaultSuccess("RTA Criada com Sucesso!")
                })
                .catch(() => showError("Falha ao Abrir RTA."))

            let justify = "";
            await axios.post(`${urlMainAPI}/justifyrta/${this.openRtaObj.id}/${false}`, JSON.stringify(justify), {
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            this.loadingTriggerList = false;

            sessionStorage.setItem('rtaReturnRoute', JSON.stringify({ name: 'rtatriggers' }));
            this.$router.push({ name: "rtadetails", params: { rtaId: rtaDetails.rtaCode, rtaData: rtaDetails, isManual: false } }).catch(err => console.error(err));
        },

        justifyRta(obj) {
            if (obj.refuseJustification == "") {
                this.canJustify = true;
            } else {
                this.canJustify = false;
                this.justifyTxt = obj.refuseJustification;
            }

            this.justifyId = obj.id;

            console.log("JUSTIFICOU RTA: ", obj)
            this.$bvModal.show("justifyTriggerModal");
        },

        showTriggerInfo(trigger) {
            this.selectedTriggerInfo = {
                creationDate: trigger.creationDate,
                process: trigger.process,
                responsible: trigger.responsible,
                workshift: trigger.workshift,
                record: trigger.record,
                motivo: trigger.refuseJustification || '-'
            };
            this.$bvModal.show("triggerInfoModal");
        },

        isValidRtaCode(record) {
            if (!record) return false;
            // Formato timestamp: yyyyMMddHHmmss (14 dígitos, ex: 20260120143045)
            if (/^\d{14}$/.test(record)) return true;
            // Formato legado: RTA-XXX
            if (record.startsWith("RTA-")) return true;
            // Formato legado antigo: YYYYMMDD + sequencial (13 dígitos, ex: 2026010800007)
            if (/^\d{13}$/.test(record)) return true;
            return false;
        },

        async openRtaFromRecord(trigger) {
            if (!this.isValidRtaCode(trigger.record)) {
                return;
            }

            this.loadingTriggerList = true;

            try {
                const rtaCode = trigger.record;

                // Tenta primeiro no endpoint de RTAs abertas
                let rtaFound = null;
                const responseOpen = await axios.get(`${urlMainAPI}/getopenrta`);

                if (responseOpen.status === 200 && responseOpen.data) {
                    rtaFound = responseOpen.data.find(rta =>
                        rta.code === rtaCode ||
                        rta.rtaCode === rtaCode
                    );
                }

                // Se não encontrou, busca em todas as RTAs (inclui concluídas/canceladas e formato antigo)
                if (!rtaFound) {
                    const responseAll = await axios.get(`${urlMainAPI}/getallrtas`);

                    if (responseAll.status === 200 && responseAll.data) {
                        rtaFound = responseAll.data.find(rta =>
                            rta.code === rtaCode ||
                            rta.rtaCode === rtaCode
                        );
                    }
                }

                if (rtaFound) {
                    // Passa o código da RTA (consistente com /rta/list) - os dados serão buscados pelo DetailsRtaDealing
                    sessionStorage.setItem('rtaReturnRoute', JSON.stringify({ name: 'rtatriggers' }));
                    sessionStorage.removeItem("currentRTA"); // Limpa dados antigos para forçar busca do backend

                    this.$router.push({
                        name: "rtadetails",
                        params: {
                            rtaId: rtaFound.rtaCode || rtaFound.code || rtaFound.id,
                            isManual: false
                        }
                    }).catch(err => console.error(err));
                } else {
                    showError("RTA não encontrada.");
                }
            } catch (error) {
                console.error("Erro ao buscar RTA:", error);
                showError("Falha ao carregar detalhes da RTA.");
            } finally {
                this.loadingTriggerList = false;
            }
        },

        async loadOpenTriggers(filters, forceReload = false) {
            this.overviewFilters = filters;

            if (!forceReload && this.onlyStatusFiltersChanged(this.keepFilters, filters)) {
                this.applyLocalStatusFilter(filters);
                return;
            }

            this.loadingTriggerList = true;
            this.keepFilters = { ...filters };

            let url = `${urlMainAPI}/getshoottriggersrta`;
            let queryMount = [];

            if (filters.processId != null && filters.processId != undefined) queryMount.push(`processId=${filters.processId}`);
            if (filters.workshiftId != null && filters.workshiftId != undefined) queryMount.push(`workshiftId=${filters.workshiftId}`);
            if (filters.startDate != null && filters.startDate != undefined && filters.startDate != "" && filters.startDate != "Data inválida") queryMount.push(`startDate=${filters.startDate}`);
            if (filters.endDate != null && filters.endDate != undefined && filters.endDate != "" && filters.endDate != "Data inválida") queryMount.push(`endDate=${filters.endDate}`);

            if (queryMount.length > 0) url += `?${queryMount.join("&")}`

            await axios.get(url)
                .then(res => {
                    if (res.status == 200) {
                        this.allTriggersData = res.data.map(trigger => {
                            const prev = Number(trigger.prevValue);
                            const li = Number(trigger.lowerLimit);
                            const ls = Number(trigger.upperLimit);
                            return {
                                ...trigger,
                                record: trigger.record || 'Pendente',
                                lowerLimitValue: (!isNaN(prev) && !isNaN(li)) ? Number((prev - prev * li / 100).toFixed(2)) : trigger.lowerLimit,
                                upperLimitValue: (!isNaN(prev) && !isNaN(ls)) ? Number((prev + prev * ls / 100).toFixed(2)) : trigger.upperLimit
                            };
                        });

                        let filteredData = this.filterByRecordStatus(this.allTriggersData, filters);

                        this.tableData = filteredData.sort((a, b) => a.id - b.id);

                        if(res.data.length == 0) defaultSuccess('Nenhum gatilho encontrado.')
                        else  defaultSuccess('Gatilhos Carregados.')
                    }

                })
                .catch(() => showError("Falha ao Carregar Gatilhos."))

            this.loadingTriggerList = false;

            this.$nextTick(() => {
                this.loadColumnFilters();
            });

        },

        async handleJustify() {
            this.$bvModal.hide("justifyTriggerModal");
            this.loadingTriggerList = true;

            let justify = this.justifyTxt;

            await axios.post(`${urlMainAPI}/justifyrta/${this.justifyId}/${true}`, JSON.stringify(justify), {
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(() => defaultSuccess("Gatilho Justificado com Sucesso!"))
                .catch(() => showError("Falha ao Justificar Gatilhos"))

            this.justifyTxt = "";
            this.loadingTriggerList = false;

            await this.loadOpenTriggers(this.keepFilters, true);
        },

        handleGenerateRtaClick() {
            this.selectedTriggers = this.tableData.filter(trigger => trigger.checked === true);

            if (this.selectedTriggers.length === 0) {
                showError("Selecione ao menos um gatilho para gerar RTA.");
                return;
            }

            if(!this.validateTriggersForAction(this.selectedTriggers, "gerar RTA")) return;

            this.$bvModal.show('gerarRtaModal');
        },

        cancelGenerateRta() {},

        async confirmGenerateRta(mainTriggerId) {
            if (!mainTriggerId) {
                showError("Selecione o gatilho principal.");
                return;
            }

            const principalTrigger = this.selectedTriggers.find(t => t.id === mainTriggerId);

            this.$bvModal.hide('gerarRtaModal');

            let creationDate = new Date();
            let deadlineDate = new Date();
            deadlineDate.setDate(deadlineDate.getDate() + this.rtaDefaultDeadlineDays);

            let rtaDetails = {
                id: -9999,
                code: "",
                rtaCode: "",
                indicatorId: principalTrigger.indicatorId,
                indicator: principalTrigger.indicator,
                processId: principalTrigger.processId,
                process: principalTrigger.process,
                workshiftId: principalTrigger.workshiftId,
                workshift: principalTrigger.workshift,
                productId: principalTrigger.productId,
                product: principalTrigger.product || "",
                equipmentId: principalTrigger.equipmentId,
                equipment: principalTrigger.equipment || "",
                triggerId: 11, // ID do trigger MAN na tabela TriggerInformation
                trigger: "MAN",
                originalTrigger: principalTrigger.trigger,
                lowerLimit: principalTrigger.lowerLimit,
                upperLimit: principalTrigger.upperLimit,
                target: principalTrigger.target || principalTrigger.prevValue,
                value: principalTrigger.value || principalTrigger.realValue,
                creationDate: moment(creationDate).format("YYYY-MM-DDTHH:mm:ss"),
                formattedCreationDate: moment(creationDate).format("YYYY-MM-DD"),
                desvioDate: principalTrigger.shootingDate || principalTrigger.creationDate,
                deadline: moment(deadlineDate).format("YYYY-MM-DDTHH:mm:ss"),
                formattedDeadline: moment(deadlineDate).format("YYYY-MM-DD"),
                actionPlanResponsibleId: principalTrigger.responsibleId || null,
                responsible: principalTrigger.responsible || "",
                accuracyResponsibleid: null,
                efficiencyRespId: null,
                efficiencyRespName: "",
                generalResponsibles: "",
                auxResponsibles: "",
                relatedRtaId: null,
                efficiencyRTAId: null,
                status: 0,
                statusId: 0,
                lastUpdate: moment(Date.now()).format("YYYY-MM-DDTHH:mm:ss"),
                description: "",
                desc: "",
                relatedfca: 0,
                mainRespId: principalTrigger.responsibleId || null,
            };

            // Marca o gatilho principal para distinguir na exibição
            const allTriggersWithFlag = this.selectedTriggers.map(t => ({
                ...t,
                isMain: Number(t.id) === Number(mainTriggerId)
            }));

            sessionStorage.setItem('rtaReturnRoute', JSON.stringify({ name: 'rtatriggers' }));
            this.$router.push({
                name: "rtadetails",
                params: {
                    rtaId: "novo",
                    rtaData: rtaDetails,
                    isManual: false,
                    secondaryTriggers: allTriggersWithFlag
                }
            }).catch(err => console.error(err));
        },

        handleJustifyClick() {
            this.selectedTriggersForJustify = this.tableData.filter(trigger => trigger.checked === true);

            if (this.selectedTriggersForJustify.length === 0) {
                showError("Selecione ao menos uma ocorrência para justificar.");
                return;
            }

            if(!this.validateTriggersForAction(this.selectedTriggersForJustify, "ser justificados")) return;

            this.$bvModal.show('justificarMassaModal');
        },

        cancelBulkJustify() {},

        async confirmBulkJustify(justifyText) {
            this.$bvModal.hide('justificarMassaModal');
            this.loadingTriggerList = true;

            try {
                const triggerIds = this.selectedTriggersForJustify.map(trigger => trigger.id);

                const response = await axios.post(`${urlMainAPI}/justifyrtabulk`, {
                    triggerIds: triggerIds,
                    justification: justifyText
                }, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });

                const justifiedCount = response.data.justifiedCount || triggerIds.length;
                defaultSuccess(`${justifiedCount} gatilho(s) justificado(s) com sucesso!`);

                this.selectedTriggersForJustify = [];
                this.tableData.forEach(trigger => trigger.checked = false);

            } catch (error) {
                showError("Falha ao justificar gatilhos");
            } finally {
                this.loadingTriggerList = false;
                await this.loadOpenTriggers(this.keepFilters, true);
            }
        },

        async handleLinkRtaClick() {
            this.selectedTriggersForLink = this.tableData.filter(trigger => trigger.checked === true);

            if (this.selectedTriggersForLink.length === 0) {
                showError("Selecione ao menos um gatilho para vincular.");
                return;
            }

            if(!this.validateTriggersForAction(this.selectedTriggersForLink, "vincular à RTA")) return;

            try {
                this.loadingLinkRta = true;
                await this.loadAvailableRtas();
                this.$bvModal.show('vincularRtaModal');
            } catch (error) {
                console.error("Erro ao carregar RTAs:", error);
            } finally {
                this.loadingLinkRta = false;
            }
        },

        async loadAvailableRtas() {
            try {
                const response = await axios.get(`${urlMainAPI}/getallrtas`);

                if (response.status === 200) {
                    this.availableRtas = response.data.map(rta => ({
                        id: rta.id,
                        rtaCode: rta.rtaCode,
                        processId: rta.processId,
                        workshiftId: rta.workshiftId,
                        indicatorName: rta.indicatorName || rta.indicator || "-",
                        processName: rta.processName || rta.process || "-",
                        workshiftName: rta.workshiftName || "-",
                        responsibleName: rta.responsibleName || rta.responsible || "-",
                        creationDate: moment(rta.creationDate).format("DD/MM/YYYY"),
                        deadline: moment(rta.deadline).format("DD/MM/YYYY"),
                        statusName: this.mapStatusToLegend(rta.status || this.getStatusName(rta.statusId)),
                    }));

                    defaultSuccess('RTAs carregadas com sucesso.');
                }
            } catch (error) {
                console.error("Erro ao carregar RTAs:", error);
                showError("Falha ao carregar RTAs disponíveis.");
            }
        },

        getStatusName(statusId) {
            const statusMap = {
                0: "Aberta",
                1: "Em Análise",
                2: "Em Análise - Atrasada",
                3: "Em Execução",
                4: "Em Execução - Atrasada",
                5: "Aguardando Avaliação",
                6: "Concluída",
                7: "Cancelada"
            };
            if (statusId === null || statusId === undefined) {
                return "Desconhecido";
            }
            const id = Number(statusId);
            return statusMap[id] ?? "Desconhecido";
        },

        mapStatusToLegend(status) {
            const statusMapping = {
                "Aberta": "Abertas",
                "Em Análise": "Em Análise",
                "Em Análise - Atrasada": "Análise em Atraso",
                "Em Execução": "Em Ações",
                "Em Execução - Atrasada": "Ações em Atraso",
                "Aguardando Avaliação": "Avaliação Pendente",
                "Concluída": "Concluída",
                "Cancelada": "Cancelada",
                "Recusada": "Recusada"
            };
            return statusMapping[status] ?? status ?? "Desconhecido";
        },

        cancelLinkRta() {},

        async loadProcess() {
            try {
                const response = await axios.get(`${urlMainAPI}/getprocess`);
                this.processOptions = response.data.map(p => ({
                    value: p.id,
                    text: p.description,
                    id: p.id,
                    description: p.description
                }));
                this.processOptions.unshift({ value: null, text: "Todos os Processos", id: null, description: "Todos os Processos" });
            } catch (error) {
                console.error("Erro ao carregar processos:", error);
            }
        },

        async confirmLinkRta(selectedRtaId) {
            if (!selectedRtaId) {
                showError("Selecione uma RTA para vincular os gatilhos.");
                return;
            }

            this.$bvModal.hide('vincularRtaModal');
            this.loadingTriggerList = true;

            const linkedTriggersToSave = this.selectedTriggersForLink.map(trigger => ({
                rtaId: selectedRtaId,
                triggerId: trigger.id,
                indicatorId: trigger.indicatorId,
                lowerLimit: trigger.lowerLimit || 0,
                upperLimit: trigger.upperLimit || 0,
                value: trigger.realValue || trigger.value || 0,
                notes: JSON.stringify({
                    creationDate: trigger.creationDate,
                    indicator: trigger.indicator,
                    process: trigger.process,
                    workshift: trigger.workshift,
                    trigger: trigger.trigger,
                    responsible: trigger.responsible,
                    prevValue: trigger.prevValue || trigger.target,
                    record: trigger.record,
                    shootingDate: trigger.shootingDate
                })
            }));

            try {
                await axios.post(`${urlMainAPI}/rta/${selectedRtaId}/linked-triggers`, linkedTriggersToSave);

                defaultSuccess("Gatilhos vinculados com sucesso!");

                this.keepFilters.statusPendente = false;
                this.keepFilters.statusRtaGerada = false;
                this.keepFilters.statusJustificada = false;

                if (this.$refs.filtersComponent) {
                    this.$refs.filtersComponent.statusPendente = false;
                    this.$refs.filtersComponent.statusRtaGerada = false;
                    this.$refs.filtersComponent.statusJustificada = false;
                }

                await this.loadOpenTriggers(this.keepFilters, true);
            } catch (error) {
                console.error("Erro ao vincular gatilhos:", error);
                showError("Falha ao vincular gatilhos à RTA.");
            } finally {
                this.loadingTriggerList = false;
            }
        },
    },
    async mounted() {
        axios.get(`${urlMainAPI}/getGeneralConfigGerencialIndicators`).then(res => {
            if (res.data) this.rtaDefaultDeadlineDays = res.data.defaultDeadlineDays ?? 7;
        });
        await Promise.all([
            this.loadOpenTriggers(this.defaultFilters),
            this.loadProcess()
        ]);
    },
}
</script>

<style scoped>
.justifyClass {
    width: 100%;
    padding: 0.3rem;
}
</style>
